/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {TrainingCourse} from "../model/TrainingCourse";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class TrainingService {

  private readonly trainingUrl: string;

  constructor(private http: HttpClient) {
    this.trainingUrl = inject(APP_CONFIG).baseUrl + '/api/trainingcourses';

  }

  getAllTraining (): Observable<TrainingCourse[]> {
    const url = `${this.trainingUrl}/all`;
    return this.http.get(url).pipe(
      map(response => response as TrainingCourse[] ));
  }

  addNew(newTrainingCourse: TrainingCourse): Observable<TrainingCourse> {
    const url = `${this.trainingUrl}`;
    return this.http.post(url, newTrainingCourse, httpOptions).pipe(
      map( newTrainingCourse => newTrainingCourse as TrainingCourse ));
  }

  updateTrainingCourse(trainingCourse: TrainingCourse): Observable<TrainingCourse> {
    var url = `${this.trainingUrl}/${trainingCourse.trainingCourseId}`;
    return this.http.put(url, trainingCourse, httpOptions).pipe(
      map( training => training as TrainingCourse ));
  }
}
